export const performanceNow = () => performance.now();
